// Owner platform billing only; never use a student's enrollment here.
export const platformAccessState = details => {
  if (!details || details.PaymentStatus == null) return 'loading';
  if (details.PaymentStatus) return 'active';
  const rawEnd = details.subscriptionEndDate || details.accessExpiresAt;
  const end = rawEnd ? new Date(rawEnd).getTime() : NaN;
  const expired = details.expired === true || (Number.isFinite(end) && end <= Date.now());
  if (expired) return details.subscriptionPlan === 'freeTrial' ? 'trial-expired' : 'subscription-expired';
  return details.subscriptionPlan ? 'inactive' : 'setup';
};

export const formatPlanDate = value => {
  if (!value || !Number.isFinite(new Date(value).getTime())) return 'Not available';
  return new Intl.DateTimeFormat('en-GB', { day:'2-digit', month:'short', year:'numeric', timeZone:'Asia/Kolkata' }).format(new Date(value));
};
